import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

function MeetKeyRedirect() {
  const { meetId: meetKey } = useParams<{ meetId: string }>();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!meetKey) return;

    const signallingUrl = process.env.REACT_APP_SIGNALLING_API_URL;
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);

    fetch(`${signallingUrl}/meet/${meetKey}/url`, { signal: controller.signal })
      .then((res) => {
        if (!res.ok) throw new Error(`Server returned ${res.status}`);
        return res.json();
      })
      .then((data: { url: string }) => {
        clearTimeout(timeoutId);
        globalThis.location.replace(data.url);
      })
      .catch((err) => {
        clearTimeout(timeoutId);
        setError(err.message);
      });

    return () => {
      clearTimeout(timeoutId);
      controller.abort();
    };
  }, [meetKey]);

  if (error) {
    return <div>Unable to resolve meeting link: {error}</div>;
  }

  return <div>Redirecting…</div>;
}

export default MeetKeyRedirect;
